import Impl2FA from "./Impl2FA";

export default Impl2FA;
